import React from 'react';
import {
  Heading,
  Text,
  Box,
  Modal,
  ModalBody,
  ModalFooter,
  Button,
} from '@razorpay/blade/components';
import { getStaticMediaUrl } from 'utils/Urls';
import fileExecutionFailure from 'assets/bulkUploads/file-execution-failure.svg';
import { BulkUploadDetailsSchemaContract } from 'schemas/BulkUploadDetailsSchema';
import { UsePreviewModalsProps } from 'components/BulkUploads/hooks/useBladePreviewModals';
import { BulkUploadStatus } from 'constants/bulkUpload';
import { ErrorAlert } from '../ErrorAlert';

export const ExecutionFailureModal = ({
  isOpen,
  bulkUploadRecord,
  clickHandlers,
}: {
  isOpen: boolean;
  bulkUploadRecord: BulkUploadDetailsSchemaContract[0];
  clickHandlers: UsePreviewModalsProps['clickHandlers'];
}) => {
  const showErrorAlert =
    [
      BulkUploadStatus.STATUS_EXECUTION_FAILED,
      BulkUploadStatus.STATUS_EXECUTION_PARTIAL_SUCCESS,
    ].includes(bulkUploadRecord?.status) && bulkUploadRecord?.error_file_url;

  return (
    <Modal isOpen={isOpen} onDismiss={() => {}} size="small">
      <ModalBody padding="spacing.0">
        <Box
          padding="spacing.7"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center">
          <Box marginBottom="spacing.5">
            <img alt="" height="70px" width="auto" src={getStaticMediaUrl(fileExecutionFailure)} />
          </Box>
          <Heading
            size="small"
            weight="semibold"
            color="surface.text.gray.normal"
            textAlign="center">
            Uploading failed!
          </Heading>
          <Text
            size="medium"
            color="surface.text.gray.muted"
            textAlign="center"
            marginTop="spacing.3">
            {showErrorAlert
              ? `${bulkUploadRecord?.number_of_rows_with_error}/${bulkUploadRecord?.total_number_of_rows} records failed to upload due to error in data. Please retry uploading after fixing the errors. `
              : 'There was an unexpected error. Please contact support or try again after sometime.'}
          </Text>
          {Boolean(showErrorAlert) && (
            <ErrorAlert
              mainText={`${bulkUploadRecord?.number_of_rows_with_error} errors found in the file`}
              subText="Please download error report > fix ALL errors > re-upload file "
              buttonText="Download Report"
              downloadURL={bulkUploadRecord?.error_file_url || ''}
              onClick={clickHandlers.onClickGetErrorReport}
            />
          )}
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.5" justifyContent="flex-end">
          {showErrorAlert ? (
            <>
              <Button
                variant="tertiary"
                onClick={() => {
                  window.location.href = '/dashboard';
                }}>
                Close
              </Button>
              <Button variant="primary" onClick={clickHandlers.onClickGoBack}>
                Re-upload
              </Button>
            </>
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                window.location.href = '/dashboard';
              }}>
              Close
            </Button>
          )}
        </Box>
      </ModalFooter>
    </Modal>
  );
};
